import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';

import { Icon, IconArrowUpL, IconArrowDownL } from '@flixbus/honeycomb-icons-react';
import { Dropdown, DropdownItem } from '@flixbus/honeycomb-react';

import { crewMemberActionLogStore } from 'pages/CrewMemberDetails/components/CrewMemberActionLog/CrewMemberActionLogStore';
import { typesGrouped } from 'pages/CrewMemberDetails/components/CrewMemberActionLog/groupedFilterTypes';

import styles from './styles.module.css';

const CrewLogTypeFilter = observer(() => {
	const [arrowUp, setArrowUp] = useState(false);
	const { filterType, setSelectedTypes } = crewMemberActionLogStore;

	const toggleArrowButton = (isActive) => {
		setArrowUp(isActive);
	};

	const handleSelection = (e, type) => {
		e.preventDefault();
		setSelectedTypes(type);
		toggleArrowButton();
	};

	const linkArray = [
		...Object.values(typesGrouped).map(({ value, name }) => (
			<DropdownItem
				Elem="a"
				href=""
				active={name === filterType.name}
				onClick={(e) => handleSelection(e, { value, name })}
				key={name}
			>
				{name}
			</DropdownItem>
		)),
	];

	return (
		<Dropdown
			active={arrowUp}
			links={linkArray}
			onToggle={toggleArrowButton}
			yPosition="bottom"
			xPosition="right"
		>
			<div className={styles.spaced}>
				<div className={styles.text}>
					<div className={styles.contain}>{filterType.name}</div>
				</div>
				<Icon
					extraClasses={styles.icon}
					InlineIcon={arrowUp ? IconArrowUpL : IconArrowDownL}
					size={3}
				/>
			</div>
		</Dropdown>
	);
});

export default CrewLogTypeFilter;
